import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import useUserStore from 'store/user.store.ts';

interface ProtectedRouteProps {
  /** User must have ALL of these permissions */
  permissions?: string[];
  /** User must have AT LEAST ONE of these roles */
  // roles?: string[];
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
  permissions = [],
  // roles = [],
}) => {
  const { user } = useUserStore();

  if (!user) return null;

  const hasPermissions =
    permissions.length === 0 ||
    permissions.every(p => user.permissions.includes(p));
  // const hasRole = roles.length === 0 || roles.some(r => user.roles.includes(r));

  if (!hasPermissions) {
    return <Navigate to='/access-denied' replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
